export const Bank = ({ isActive }) => (
  <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.041 7.70833V14.375M12.7077 14.375V7.70833M3.95768 7.70833V14.375M7.29102 14.375V7.70833M15.6731 14.375H4.32561C3.60823 14.375 2.97133 14.834 2.74448 15.5146L2.65663 15.7781C2.47676 16.3177 2.87841 16.875 3.4472 16.875H16.5515C17.1203 16.875 17.5219 16.3177 17.3421 15.7781L17.2542 15.5146C17.0274 14.834 16.3905 14.375 15.6731 14.375ZM16.6361 7.70833H3.36259C2.77077 7.70833 2.29102 7.22857 2.29102 6.63676C2.29102 6.23248 2.51855 5.86261 2.87939 5.68031L9.24781 2.463C9.7204 2.22426 10.2783 2.22426 10.7509 2.463L17.1193 5.68031C17.4802 5.86261 17.7077 6.23248 17.7077 6.63676C17.7077 7.22857 17.2279 7.70833 16.6361 7.70833Z"
      stroke={isActive ? "#225AEA" : "currentColor"}
      strokeWidth="1.5"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
  </svg>
)

export default Bank
